import { create } from "zustand";

interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  role: "super_admin" | "property_manager" | "tenant";
  phone_number: string | null;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setAuth: (user: User, access: string, refresh: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: (() => {
    try {
      const u = localStorage.getItem("user");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })(),
  accessToken: localStorage.getItem("access_token"),

  setAuth: (user, access, refresh) => {
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("access_token", access);
    localStorage.setItem("refresh_token", refresh);
    set({ user, accessToken: access });
  },

  logout: () => {
    localStorage.clear();
    set({ user: null, accessToken: null });
  },
}));
